import MenuIcon from 'src/app.core/linkareer/svgIcon/MenuIcon';
import { TabBarItemProps } from '../types/tabBar.types';
import CommunityIcon from 'src/app.core/linkareer/svgIcon/CommunityIcon';
import HomeIcon from 'src/app.core/linkareer/svgIcon/HomeIcon';
import CalenderIcon from 'src/app.core/linkareer/svgIcon/CalenderIcon';
import IconLinkareerSTEMSymbol from 'src/app.core/linkareer/svgIcon/IconLinkareerSTEMSymbol';

interface GetTabBarDataParameter {
  activedTabPathname: string;
}

interface TabBarDataType {
  menu: TabBarItemProps;
  community: TabBarItemProps;
  home: TabBarItemProps;
  calender: TabBarItemProps;
  linkareerSTEM: TabBarItemProps;
}

const getTabBarData = ({ activedTabPathname }: GetTabBarDataParameter): TabBarDataType => {
  const TAB_BAR_DATA: TabBarDataType = {
    menu: {
      icon: <MenuIcon isActive={activedTabPathname === '/menu'} />,
      isActive: activedTabPathname === '/nav',
      label: '메뉴',
    },
    community: {
      icon: <CommunityIcon isActive={false} />,
      isActive: false,
      label: '커뮤니티',
    },
    home: {
      icon: <HomeIcon isActive={activedTabPathname === '/'} />,
      isActive: activedTabPathname === '/',
      label: '홈',
    },
    calender: {
      icon: <CalenderIcon isActive={activedTabPathname === '/calender'} />,
      isActive: activedTabPathname === '/calender',
      label: '공고달력',
    },
    linkareerSTEM: {
      icon: <IconLinkareerSTEMSymbol />,
      isActive: false,
      label: '링커리어 STEM',
    },
  };

  return TAB_BAR_DATA;
};

export default getTabBarData;
